// This file is just added for convenience so this repository can be
// directly checked out into a project's deps folder
module.exports = require('./lib/async');



//////////////////
// WEBPACK FOOTER
// ./~/async/index.js
// module id = 14
// module chunks = 0